(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
function initAnnouncementBar() {
  const bars = document.querySelectorAll('.ann-bar');
  
  bars.forEach(bar => {
    if (bar.dataset.announcementInitialized === 'true') return;
    bar.dataset.announcementInitialized = 'true';

    const count = parseInt(bar.dataset.blockCount);
    if (count <= 1) return;

    const slides = bar.querySelectorAll('.ann-bar__slide');
    let current = 0;

    setInterval(() => {
      slides[current].classList.remove('is-active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-active');
    }, 5000); // 5 seconds per slide
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAnnouncementBar);
} else {
  initAnnouncementBar();
}

document.addEventListener('shopify:section:load', initAnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
(function () {
  function cartSections(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = [];

    if (scope.matches && scope.matches('[data-cart-page]')) {
      sections.push(scope);
    }

    scope.querySelectorAll('[data-cart-page]').forEach(function (section) {
      sections.push(section);
    });

    return sections;
  }

  function initCartPage(root) {
    cartSections(root).forEach(function (section) {
      if (section.dataset.cartInitialized === 'true') return;
      section.dataset.cartInitialized = 'true';

      var form = section.querySelector('form');
      if (!form) return;
      var busy = false;
      var failed = false;
      var sectionId = section.dataset.cartPage;
      var header = document.querySelector('#site-header');
      var headerWrapper = header && header.closest('[id^="shopify-section-"]');
      var headerId = headerWrapper && headerWrapper.id.replace('shopify-section-', '');
      var sectionIds = headerId ? [sectionId, headerId] : [sectionId];
      var errorElement = section.querySelector('[data-cart-error]');
      var defaultError = errorElement.dataset.defaultError;

      function setBusy(value) {
        busy = value;
        section.setAttribute('aria-busy', String(value));
        section.querySelector('[data-cart-updating]').hidden = !value;
        section.querySelectorAll('[data-qty-input], [data-qty-plus], [data-qty-minus]').forEach(function (control) {
          control.disabled = value;
        });
        updateSelection();
      }

      async function fetchCart(url, options) {
        var controller = new AbortController();
        var timeout = setTimeout(function () { controller.abort(); }, 12000);
        try {
          return await fetch(url, Object.assign({}, options, { signal: controller.signal }));
        } finally {
          clearTimeout(timeout);
        }
      }

      function renderSections(rendered) {
        var html = rendered && rendered[sectionId];
        if (!html) throw new Error(defaultError);
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var next = parsed.querySelector('[data-cart-page]');
        if (!next) throw new Error(defaultError);
        var selections = [];
        section.querySelectorAll('[data-cart-item]').forEach(function (item) {
          selections.push({ key: item.dataset.cartKey, identity: item.dataset.cartIdentity, checked: item.querySelector('[data-cart-check]').checked });
        });
        var active = document.activeElement;
        var activeItem = active && active.closest('[data-cart-item]');
        var activeIdentity = activeItem && activeItem.dataset.cartIdentity;
        var focusSelector = active && active.matches('[data-qty-input]') ? '[data-qty-input]' : active && active.matches('[data-qty-minus]') ? '[data-qty-minus]' : '[data-qty-plus]';
        next.querySelectorAll('[data-cart-item]').forEach(function (item) {
          var index = selections.findIndex(function (entry) { return entry.key === item.dataset.cartKey; });
          if (index < 0) index = selections.findIndex(function (entry) { return entry.identity === item.dataset.cartIdentity; });
          if (index >= 0) item.querySelector('[data-cart-check]').toggleAttribute('checked', selections.splice(index, 1)[0].checked);
        });
        if (headerId && rendered[headerId]) {
          var nextHeader = new DOMParser().parseFromString(rendered[headerId], 'text/html');
          var links = nextHeader.querySelectorAll('.hd-icon--cart, .side-menu__cart');
          document.querySelectorAll('.hd-icon--cart, .side-menu__cart').forEach(function (link, index) {
            if (!links[index]) return;
            link.innerHTML = links[index].innerHTML;
            link.setAttribute('aria-label', links[index].getAttribute('aria-label'));
          });
        }
        section.innerHTML = next.innerHTML;
        section.className = next.className;
        section.removeAttribute('aria-busy');
        delete section.dataset.cartInitialized;
        initCartPage(section);
        if (activeIdentity) {
          var focusItem = Array.from(section.querySelectorAll('[data-cart-item]')).find(function (item) { return item.dataset.cartIdentity === activeIdentity; });
          var focusTarget = focusItem ? focusItem.querySelector(focusSelector) : section.querySelector('[data-select-all]');
          if (focusTarget) focusTarget.focus({ preventScroll: true });
        }
      }

      async function changeQuantity(item, input) {
        if (busy) return;
        var quantity = Number(input.value);
        if (input.value.trim() === '' || !Number.isFinite(quantity) || quantity < 0 || !Number.isInteger(quantity)) {
          input.value = input.defaultValue;
          return;
        }
        if (quantity === Number(input.defaultValue) && !failed) return;
        errorElement.hidden = true;
        section.querySelector('[data-cart-reload]').hidden = true;
        failed = false;
        setBusy(true);
        var mutationSucceeded = false;
        var failureMessage = defaultError;
        try {
          var response = await fetchCart(form.getAttribute('action') + '/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: item.dataset.cartKey, quantity: quantity, sections: sectionIds, sections_url: form.getAttribute('action') })
          });
          var cart = await response.json();
          if (!response.ok) {
            failureMessage = typeof cart.description === 'string' ? cart.description : defaultError;
            throw new Error(failureMessage);
          }
          mutationSucceeded = true;
          if (!section.isConnected) return;
          renderSections(cart.sections);
        } catch (error) {
          if (!section.isConnected) return;
          try {
            var url = new URL(form.getAttribute('action'), window.location.origin);
            url.searchParams.set('sections', sectionIds.join(','));
            var recovery = await fetchCart(url.pathname + url.search, { cache: 'no-store', headers: { 'Accept': 'application/json' } });
            if (!recovery.ok) throw new Error(defaultError);
            var rendered = await recovery.json();
            if (!section.isConnected) return;
            renderSections(rendered);
            if (!mutationSucceeded) {
              var recoveredError = section.querySelector('[data-cart-error]');
              if (recoveredError) {
                recoveredError.textContent = failureMessage;
                recoveredError.hidden = false;
              }
            }
          } catch (recoveryError) {
            failed = true;
            input.value = input.defaultValue;
            errorElement.textContent = failureMessage;
            errorElement.hidden = false;
            section.querySelector('[data-cart-reload]').hidden = false;
            setBusy(false);
          }
        }
      }

      form.addEventListener('submit', function (event) {
        if (busy || failed) event.preventDefault();
      });
      form.addEventListener('click', function (event) {
        if (busy && event.target.closest('.cart-item__remove')) event.preventDefault();
      });

      section.querySelectorAll('[data-cart-item]').forEach(function (item) {
        var input = item.querySelector('[data-qty-input]');
        var minus = item.querySelector('[data-qty-minus]');
        var plus = item.querySelector('[data-qty-plus]');

        if (minus && input) {
          minus.addEventListener('click', function () {
            input.value = Math.max(0, parseInt(input.value || '0', 10) - 1);
            changeQuantity(item, input);
          });
        }

        if (plus && input) {
          plus.addEventListener('click', function () {
            input.value = parseInt(input.value || '0', 10) + 1;
            changeQuantity(item, input);
          });
        }

        if (input) input.addEventListener('change', function () { changeQuantity(item, input); });
      });

      var selectAll = section.querySelector('[data-select-all]');
      var deselectAll = section.querySelector('[data-deselect-all]');
      var selectedCheckout = section.querySelector('[data-selected-checkout]');
      var checks = section.querySelectorAll('[data-cart-check]');

      function updateSelection() {
        var selectedCount = section.querySelectorAll('[data-cart-check]:checked').length;
        if (selectAll) {
          selectAll.checked = selectedCount === checks.length;
          selectAll.indeterminate = selectedCount > 0 && selectedCount < checks.length;
        }
        if (deselectAll) deselectAll.disabled = selectedCount === 0;
        section.querySelectorAll('[name="checkout"]').forEach(function (button) {
          button.disabled = busy || failed || (button.hasAttribute('data-selected-checkout') && selectedCount === 0);
        });
      }

      function setSelection(checked) {
        checks.forEach(function (checkbox) {
          checkbox.checked = checked;
        });
        updateSelection();
      }

      if (selectAll) {
        selectAll.addEventListener('change', function () {
          setSelection(selectAll.checked);
        });
      }

      if (deselectAll) {
        deselectAll.addEventListener('click', function () {
          setSelection(false);
        });
      }

      checks.forEach(function (checkbox) {
        checkbox.addEventListener('change', updateSelection);
      });
      updateSelection();

      if (selectedCheckout) {
        selectedCheckout.addEventListener('click', function (event) {
          var checkedItems = section.querySelectorAll('[data-cart-check]:checked');
          if (!checkedItems.length) {
            event.preventDefault();
            return;
          }

          section.querySelectorAll('[data-cart-item]').forEach(function (item) {
            var checked = item.querySelector('[data-cart-check]');
            var quantity = item.querySelector('[data-qty-input]');
            if (checked && quantity && !checked.checked) {
              quantity.value = 0;
            }
          });
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartPage);
  } else {
    initCartPage();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCartPage(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
(function () {
  function collectionSections(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = [];

    if (scope.matches && scope.matches('[data-collection-section]')) {
      sections.push(scope);
    }

    scope.querySelectorAll('[data-collection-section]').forEach(function (section) {
      sections.push(section);
    });

    return sections;
  }

  function initCollectionSections(root) {
    collectionSections(root).forEach(function (section) {
      if (section.dataset.collectionInitialized === 'true') return;
      section.dataset.collectionInitialized = 'true';

      var grid = section.querySelector('.collection-grid');
      var sortButton = section.querySelector('.collection-toolbar__filter-button');
      var sortOptions = section.querySelector('.collection-toolbar__sort-options');

      section.querySelectorAll('[data-grid-count]').forEach(function (button) {
        button.addEventListener('click', function () {
          if (!grid) return;
          var count = button.getAttribute('data-grid-count');
          grid.classList.toggle('collection-grid--4', count === '4');
          grid.classList.toggle('collection-grid--3', count !== '4');
          section.querySelectorAll('[data-grid-count]').forEach(function (item) {
            var active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        });
      });

      if (sortButton && sortOptions) {
        sortButton.addEventListener('click', function () {
          var isOpen = sortButton.getAttribute('aria-expanded') === 'true';
          sortButton.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          sortOptions.hidden = isOpen;
        });

        document.addEventListener('click', function (event) {
          if (!section.contains(event.target)) return;
          if (event.target.closest('.collection-toolbar__sort')) return;
          sortButton.setAttribute('aria-expanded', 'false');
          sortOptions.hidden = true;
        });
      }

    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionSections);
  } else {
    initCollectionSections();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCollectionSections(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
function initHeader() {
  var header = document.getElementById('site-header');
  if (!header || header.dataset.headerInitialized === 'true') return;
  header.dataset.headerInitialized = 'true';

  /* ── PC Dropdown ────────────────────────────── */
  var dropdown = document.getElementById('hd-dropdown');
  var activePanel = null;

  function positionDropdown() {
    if (!dropdown || !header) return;
    dropdown.style.top = header.getBoundingClientRect().bottom + 'px';
  }

  function alignDropdown(panelId) {
    if (!dropdown) return;
    var panel = dropdown.querySelector('[data-panel="' + panelId + '"]');
    if (!panel) return;
    
    // Only apply dynamic alignment to vertical menus
    var menu = panel.querySelector('.mega-menu--vertical');
    var trigger = document.querySelector('[data-dd="' + panelId + '"]');
    if (menu && trigger) {
      var triggerRect = trigger.getBoundingClientRect();
      var panelRect = panel.getBoundingClientRect();
      var offsetLeft = triggerRect.left - panelRect.left;
      var centerOffset = offsetLeft + (triggerRect.width / 2);
      
      menu.style.margin = '0';
      menu.style.marginLeft = centerOffset + 'px';
      menu.style.transform = 'translateX(-50%)';
      menu.style.width = 'max-content';
      menu.style.justifyContent = 'flex-start';
      menu.style.alignItems = 'flex-start';
    } else {
      // Ensure multi-column menus reset to their default centered CSS behavior
      var standardMenu = panel.querySelector('.mega-menu:not(.mega-menu--vertical)');
      if (standardMenu) {
        standardMenu.style.margin = '';
        standardMenu.style.marginLeft = '';
        standardMenu.style.transform = '';
        standardMenu.style.width = '';
      }
    }
  }

  function handleResize() {
    if (activePanel) {
      positionDropdown();
      alignDropdown(activePanel);
    }
  }
  window.addEventListener('resize', handleResize);

  function openDropdown(panelId) {
    if (!dropdown) return;
    dropdown.querySelectorAll('.dd-panel').forEach(function (p) { p.classList.remove('is-active'); });
    var panel = dropdown.querySelector('[data-panel="' + panelId + '"]');
    if (!panel) return;
    panel.classList.add('is-active');
    
    alignDropdown(panelId);
    positionDropdown();
    dropdown.classList.add('is-open');
    dropdown.removeAttribute('aria-hidden');
    if (header) header.classList.add('is-dropdown-open');
    activePanel = panelId;
  }

  function closeDropdown() {
    if (!dropdown) return;
    dropdown.classList.remove('is-open');
    dropdown.setAttribute('aria-hidden', 'true');
    dropdown.querySelectorAll('.dd-panel').forEach(function (p) { p.classList.remove('is-active'); });
    document.querySelectorAll('[data-dd]').forEach(function (el) { el.setAttribute('aria-expanded', 'false'); });
    if (header) header.classList.remove('is-dropdown-open');
    activePanel = null;
  }

  document.querySelectorAll('[data-dd]').forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var panelId = this.getAttribute('data-dd');
      if (activePanel === panelId) {
        closeDropdown();
      } else {
        document.querySelectorAll('[data-dd]').forEach(function (el) { el.setAttribute('aria-expanded', 'false'); });
        trigger.setAttribute('aria-expanded', 'true');
        openDropdown(panelId);
      }
    });
  });

  document.addEventListener('click', function (e) {
    if (activePanel && !dropdown.contains(e.target) && !e.target.closest('[data-dd]')) {
      closeDropdown();
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDropdown(); });

  /* ── Mobile side menu ───────────────────────── */
  var sideMenu = document.getElementById('mobile-side-menu');
  var sideOverlay = document.getElementById('side-menu-overlay');
  var mobileToggle = document.querySelector('.mobile-toggle');
  var sideClose = document.querySelector('.side-menu__close');

  function openSideMenu() {
    if (!sideMenu || !mobileToggle) return;
    sideMenu.hidden = false;
    if (sideOverlay) sideOverlay.hidden = false;
    requestAnimationFrame(function () { sideMenu.classList.add('is-open'); });
    sideMenu.removeAttribute('aria-hidden');
    mobileToggle.setAttribute('aria-expanded', 'true');
    mobileToggle.querySelector('.mobile-toggle__open').hidden = true;
    mobileToggle.querySelector('.mobile-toggle__close').hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeSideMenu() {
    if (!sideMenu || !mobileToggle) return;
    sideMenu.classList.remove('is-open');
    sideMenu.setAttribute('aria-hidden', 'true');
    mobileToggle.setAttribute('aria-expanded', 'false');
    mobileToggle.querySelector('.mobile-toggle__open').hidden = false;
    mobileToggle.querySelector('.mobile-toggle__close').hidden = true;
    document.body.style.overflow = '';
    setTimeout(function () {
      sideMenu.hidden = true;
      if (sideOverlay) sideOverlay.hidden = true;
    }, 320);
  }

  if (mobileToggle) {
    mobileToggle.addEventListener('click', function () {
      if (sideMenu.hidden) { openSideMenu(); } else { closeSideMenu(); }
    });
  }
  if (sideClose) sideClose.addEventListener('click', closeSideMenu);
  if (sideOverlay) sideOverlay.addEventListener('click', closeSideMenu);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sideMenu.hidden) closeSideMenu(); });

  /* ── Mobile sub-panels ──────────────────────── */
  document.querySelectorAll('.side-menu__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var panelId = this.getAttribute('data-panel');
      var panel = document.getElementById(panelId);
      var isOpen = this.getAttribute('aria-expanded') === 'true';

      document.querySelectorAll('.side-menu__panel').forEach(function (p) {
        p.classList.remove('is-active');
        p.hidden = true;
        p.setAttribute('aria-hidden', 'true');
      });
      document.querySelectorAll('.side-menu__trigger').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });

      if (!isOpen && panel) {
        panel.classList.add('is-active');
        panel.hidden = false;
        panel.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ── Scroll effect ──────────────────────────── */
  var headers = document.querySelectorAll('.site-header--transparent');
  var heroSlider = document.querySelector('.hero-slider');
  
  function handleScroll() {
    var threshold = 50;
    if (heroSlider) {
      threshold = heroSlider.offsetHeight - 50; // Trigger slightly before the end for a smoother transition
    }
    
    var scrolled = window.scrollY > threshold;
    headers.forEach(function(h) {
      if (scrolled) { h.classList.add('is-scrolled'); }
      else { h.classList.remove('is-scrolled'); }
    });
  }
  window.addEventListener('scroll', handleScroll);
  handleScroll();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeader);
} else {
  initHeader();
}

document.addEventListener('shopify:section:load', initHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee-ticker"]) return;
  try {
    
function initMarqueeTicker() {
  var ticker = document.getElementById('marquee-ticker');
  if (!ticker) return;
  if (ticker.dataset.marqueeInitialized === 'true') return;
  ticker.dataset.marqueeInitialized = 'true';

  // Session storage check for dismissible state
  if (sessionStorage.getItem('heydudu_marquee_closed') === 'true') {
    document.body.classList.remove('has-marquee-ticker');
    ticker.style.display = 'none';
    return;
  }

  document.body.classList.add('has-marquee-ticker');

  var footer = document.querySelector('.footer');

  var closeBtn = ticker.querySelector('.marquee-ticker__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      ticker.style.display = 'none';
      document.body.classList.remove('has-marquee-ticker');
      if (footer) footer.style.marginTop = '0px';
      sessionStorage.setItem('heydudu_marquee_closed', 'true');
    });
  }

  // Locking state observer relative to footer
  if (footer) {
    // Move the ticker inside the footer to share its coordinate space
    footer.style.position = 'relative';
    footer.style.marginTop = '39px'; // Create physical space so it doesn't overlap previous section
    footer.appendChild(ticker);

    function updateTickerPosition() {
      var footerRect = footer.getBoundingClientRect();
      var windowHeight = window.innerHeight;
      
      // If the top of the footer is visible in the viewport
      if (footerRect.top <= windowHeight) {
        // Lock it natively to the top of the footer (no transform jitter)
        ticker.style.position = 'absolute';
        ticker.style.top = '-39px'; // Height of the ticker + 1px for footer border
        ticker.style.bottom = 'auto';
        ticker.style.transform = 'none';
      } else {
        // Floating state
        ticker.style.position = 'fixed';
        ticker.style.top = 'auto';
        ticker.style.bottom = '0px';
        ticker.style.transform = 'none';
      }
    }

    // Since we are just toggling static CSS properties, the browser handles 
    // the actual pixel movement natively, completely eliminating scroll flashing.
    window.addEventListener('scroll', updateTickerPosition, { passive: true });
    window.addEventListener('resize', updateTickerPosition, { passive: true });
    updateTickerPosition(); // Initial check
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMarqueeTicker);
} else {
  initMarqueeTicker();
}

document.addEventListener('shopify:section:load', initMarqueeTicker);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-related"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('heydudu-complementary-products')) {
  customElements.define('heydudu-complementary-products', class extends HTMLElement {
    connectedCallback() {
      if (this.request || this.dataset.state !== 'idle') return;
      this.loadRecommendations();
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.request?.abort();
      this.request = null;
      if (this.dataset.state === 'loading') this.dataset.state = 'idle';
    }

    async loadRecommendations() {
      const request = new AbortController();
      this.request = request;
      this.dataset.state = 'loading';
      this.timer = setTimeout(() => request.abort(), 15000);
      try {
        const url = new URL(this.dataset.url, location.origin);
        if (url.origin !== location.origin || url.searchParams.get('intent') !== 'complementary') throw new Error('Invalid recommendation endpoint');
        const response = await fetch(url.href, { signal: request.signal, credentials: 'same-origin', headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Recommendations unavailable');
        const html = await response.text();
        if (!this.isConnected || this.request !== request || request.signal.aborted) return;
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const source = [...documentFragment.querySelectorAll('heydudu-complementary-products')].find(element => element.dataset.sectionId === this.dataset.sectionId && element.dataset.productId === this.dataset.productId);
        const content = source?.querySelector('[data-recommendations-content]');
        if (content?.querySelector('.product-card')) {
          this.querySelector('[data-recommendations-content]').replaceWith(document.importNode(content, true));
          this.dataset.state = 'loaded';
        } else {
          this.dataset.state = 'empty';
        }
      } catch {
        if (this.isConnected && this.request === request) this.dataset.state = 'error';
      } finally {
        if (this.request === request) {
          clearTimeout(this.timer);
          this.request = null;
        }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
(function () {
  function searchSections(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = [];

    if (scope.matches && scope.matches('[data-search-section]')) {
      sections.push(scope);
    }

    scope.querySelectorAll('[data-search-section]').forEach(function (section) {
      sections.push(section);
    });

    return sections;
  }

  function initSearchSections(root) {
    searchSections(root).forEach(function (section) {
      if (section.dataset.searchInitialized === 'true') return;
      section.dataset.searchInitialized = 'true';

      var grid = section.querySelector('.search-grid');
      var sortButton = section.querySelector('.search-toolbar__filter-button');
      var sortOptions = section.querySelector('.search-toolbar__sort-options');

      section.querySelectorAll('[data-search-grid-count]').forEach(function (button) {
        button.addEventListener('click', function () {
          if (!grid) return;
          var count = button.getAttribute('data-search-grid-count');
          grid.classList.toggle('search-grid--4', count === '4');
          grid.classList.toggle('search-grid--3', count !== '4');
          section.querySelectorAll('[data-search-grid-count]').forEach(function (item) {
            var active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        });
      });

      if (sortButton && sortOptions) {
        sortButton.addEventListener('click', function () {
          var isOpen = sortButton.getAttribute('aria-expanded') === 'true';
          sortButton.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          sortOptions.hidden = isOpen;
        });

        document.addEventListener('click', function (event) {
          if (!section.contains(event.target)) return;
          if (event.target.closest('.search-toolbar__sort')) return;
          sortButton.setAttribute('aria-expanded', 'false');
          sortOptions.hidden = true;
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchSections);
  } else {
    initSearchSections();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSearchSections(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
